export {default} from '../../../core/components/Repository/FieldBarcode';